import { buildUrl } from "@shared/utils/buildUrl";
import { BalanceDocType } from "@src/types/business/balanceDocType";
import { AppPaths } from "./paths";
import { OPEN_FILTER_QUERY_PARAM, QUERY_PARAM_TRIGGER_VALUE } from "./queryParams";

const OPEN_FILTER = {
    [OPEN_FILTER_QUERY_PARAM]: QUERY_PARAM_TRIGGER_VALUE,
} as const;

/**
 * Маппинг задач модуля «Учёт в производстве» на роуты приложения.
 *
 * Ключи — полный путь задачи (`FolderName/Name`, как в OMP),
 * значения — URL роуты приложения.
 */
const WORKSHOP_STOCK_TASK_ROUTE_MAP: Record<string, string> = {
    "Учёт в производстве/Акты инвентаризации": buildUrl(AppPaths.WORKSHOP.INV_ACTS.LIST, OPEN_FILTER),
    "Учёт в производстве/Внутризаводские накладные (Приход)": buildUrl(
        AppPaths.WORKSHOP.INPLANTS.LIST(BalanceDocType.Arrival),
        OPEN_FILTER,
    ),
    "Учёт в производстве/Внутризаводские накладные (Расход)": buildUrl(
        AppPaths.WORKSHOP.INPLANTS.LIST(BalanceDocType.Leave),
        OPEN_FILTER,
    ),
    "Учёт в производстве/Лимитные карты (Приход)": buildUrl(AppPaths.WORKSHOP.LIMIT_CARDS.LIST, OPEN_FILTER),
    "Учёт в производстве/Цеховая номенклатура": buildUrl(AppPaths.WORKSHOP.DEPOT.LIST, OPEN_FILTER),
};

/**
 * Маппинг задач модуля «Складской учёт» на роуты-заглушки.
 *
 * Полные экраны по дорожной карте (README) будут подключены позже.
 */
const WAREHOUSE_TASK_ROUTE_MAP: Record<string, string> = {
    "Складской учёт/Размещение ТМЦ": buildUrl(AppPaths.STOCK.PLACEMENT.LIST, OPEN_FILTER),
    "Складской учёт/Комплектация «КАНБАН»": buildUrl(AppPaths.STOCK.KANBAN_SUPPLY.LIST, OPEN_FILTER),
    "Складской учёт/Комплектация по КВ": buildUrl(AppPaths.STOCK.PICKING_LISTS.LIST, OPEN_FILTER),
    "Складской учёт/Приёмка на СГП": buildUrl(AppPaths.STOCK.FG_RECEIPT.LIST, OPEN_FILTER),
    "Складской учёт/Отгрузка СГП": buildUrl(AppPaths.STOCK.FG_SHIPMENT.LIST, OPEN_FILTER),
    "Складской учёт/Полная инвентаризация склада": buildUrl(AppPaths.STOCK.FULL_INVENTORY.LIST, OPEN_FILTER),
    "Складской учёт/Частичная инвентаризация склада": buildUrl(AppPaths.STOCK.PARTIAL_INVENTORY.LIST, OPEN_FILTER),
};

/**
 * Маппинг задач на роуты приложения.
 */
export const TASK_TO_APP_ROUTE_MAP: Record<string, string> = {
    ...WORKSHOP_STOCK_TASK_ROUTE_MAP,
    ...WAREHOUSE_TASK_ROUTE_MAP,
};

/**
 * Получает роут приложения по пути и имени узла дерева задач.
 * @param nodePath путь папки (`FolderName`)
 * @param nodeName имя задачи (`Name`)
 */
export function getAppRouteByNode(nodePath: string, nodeName: string): string | undefined {
    const nodeFullPath = [nodePath.replaceAll("\\", "/"), nodeName].filter((part) => part !== "").join("/");
    return TASK_TO_APP_ROUTE_MAP[nodeFullPath];
}
